;!function(){try{var e="undefined"!=typeof window?window:"undefined"!=typeof global?global:"undefined"!=typeof globalThis?globalThis:"undefined"!=typeof self?self:{};e._sentryModuleMetadata=e._sentryModuleMetadata||{},e._sentryModuleMetadata[(new e.Error).stack]=Object.assign({},e._sentryModuleMetadata[(new e.Error).stack],{"_sentryBundlerPluginAppKey:native-teams-frontend":true});}catch(e){}}();const TOKEN_QUERY_PARAM_NAMES = new Set([
  'token',
  'access_token',
  'refresh_token',
  'id_token',
  'auth_token',
  'oauth_token',
]);

function shouldOmitTokenQueryParam(name: string): boolean {
  const lower = name.toLowerCase();
  return TOKEN_QUERY_PARAM_NAMES.has(lower) || lower.endsWith('_token');
}

function stripTokenQueryParamsFromSearch(search: string): string {
  if (!search || search === '?') return '';

  const params = new URLSearchParams(search.startsWith('?') ? search.slice(1) : search);
  for (const key of [...params.keys()]) {
    if (shouldOmitTokenQueryParam(key)) {
      params.delete(key);
    }
  }

  const serialized = params.toString();
  return serialized ? `?${serialized}` : '';
}

/**
 * Removes token-like query params before URLs are stored in logs or Sentry tags.
 * Other params (tab, userId, organisationId, etc.) are kept for debugging context.
 */
export function sanitizeRequestUrlForLogging(url: string): string {
  const trimmed = url.trim();
  if (!trimmed) return trimmed;

  try {
    const parsed = new URL(trimmed);
    const search = stripTokenQueryParamsFromSearch(parsed.search);
    return `${parsed.origin}${parsed.pathname}${search}`;
  } catch {
    const withoutHash = trimmed.split('#')[0] ?? trimmed;
    const questionIndex = withoutHash.indexOf('?');
    if (questionIndex === -1) return withoutHash;

    const path = withoutHash.slice(0, questionIndex);
    const search = stripTokenQueryParamsFromSearch(withoutHash.slice(questionIndex));
    return `${path}${search}`;
  }
}
